import React from 'react'

const LaunchIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.25 5H4.375C3.87772 5 3.40081 5.19754 3.04917 5.54917C2.69754 5.90081 2.5 6.37772 2.5 6.875V15.625C2.5 16.1223 2.69754 16.5992 3.04917 16.9508C3.40081 17.3025 3.87772 17.5 4.375 17.5H13.125C13.6223 17.5 14.0992 17.3025 14.4508 16.9508C14.8025 16.5992 15 16.1223 15 15.625V8.75M6.25 13.75L17.5 2.5M17.5 2.5H13.125M17.5 2.5V6.875" stroke="#2158D0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default LaunchIcon